import { TabularTypeSettings } from './tabular-type-settings';
import { DatasetFormatType } from './dataflow-dataset-settings';
import { Metamodel } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.smartsheet.dataflowSettings
})
export class SmartsheetSettings extends TabularTypeSettings {
    public getDatasetType(): string {
        // for now, Smartsheet only support inline mode, it does not have dataset
        return undefined;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.Smartsheet;
    }

    public getIconClass(): string {
        return 'i-100x100-smartsheet';
    }

    public getSubFormat(): string {
        return undefined;
    }
}
